import React from "react";
import ReactDOM from "react-dom";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import "./alert.scss";

export var Alert = (props) => {
    const modalRoot = document.getElementById('modal-root');

    return ReactDOM.createPortal(
        <AlertInternals {...props} />,
        modalRoot
    )
}

var AlertInternals = (props) => {
    var classes = ["alert-viewport"]
    if (props.show === true) { classes.push("alert-show"); } else { classes.push("alert-hide"); }
    if (props.className !== undefined) { classes.push(props.className); }

    return (
        <div className={ classes.join(" ") }>
            <div className="alert-viewport-bg1" />

            <div className="alert">
                { props.children }
            </div>
        </div>
    )
}

export var AlertContent = (props) => {
    var classes = ["alert-content"]
    if (props.className !== undefined) { classes.push(props.className); }

    return (
        <div {...props} className={ classes.join(" ") } />
    )
}

export var AlertMessageTemplate = (props) => {
    return (
        <div style={{ padding: 10, ...props.style }} className={props.className} >
            <div style={{ position: "absolute", top: 14, left: 20 }}>
                <h1><FontAwesomeIcon icon={props.icon} /></h1>
            </div>
            <div style={{ width: "calc(100% - 50px)", position: "relative", top: 0, left: 50 }}>
                <h1>{props.title}</h1>
                <p>{props.description}</p>

                {props.children}
            </div>
        </div>
    )
}

export var AlertFooter = (props) => {
    return (
        <div className="alert-footer">
            <div>
                {props.left}
            </div>
            <div>
                {props.right}
            </div>
        </div>
    )
}